<template>
  <HomePanel ref="target" title="执业资格">
    <template v-slot:right>
      <div class="sub">
        <RouterLink target="_blank" to="/video?firstCate=206&secondCate=206">
          <el-button plain>执业医师</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/video?firstCate=206&secondCate=374">
          <el-button plain>执业药师</el-button></RouterLink
        >
        <RouterLink target="_blank" to="/video?firstCate=206&secondCate=154">
          <el-button plain>执业护士</el-button>
        </RouterLink>
        <RouterLink target="_blank" to="/video?firstCate=206&secondCate=157">
          <el-button plain>执业兽医师</el-button>
        </RouterLink>
      </div>
      <ShMore target="_blank" to="/video?firstCate=206" />
    </template>
    <div class="box">
      <Transition name="fade">
        <div v-if="sideImg.length" class="box-img">
          <RouterLink
            target="_blank"
            class="cover"
            :to="`${sideImg[0]?.bannerUrl}`"
          >
            <img
              style="width: 240px"
              v-lazy="sideImg[0]?.bannerImg"
              :alt="sideImg[0]?.bannerDesc"
            />
          </RouterLink>
        </div>
        <SideImgSkeleton v-else />
      </Transition>
      <LessonItem :goods="goods" />
    </div>
  </HomePanel>
</template>

<script>
import SideImgSkeleton from "./side-img-skeleton.vue";
import HomePanel from "./home-panel.vue";
import ShMore from "@/components/library/sh-more.vue";
import LessonItem from "./lesson-item.vue";
import { useLazyData } from "@/hooks";
import { findZhiYe } from "@/api/home";
import { ref } from "vue";
export default {
  name: "HomeLesson",
  components: {
    HomePanel,
    ShMore,
    LessonItem,
    SideImgSkeleton,
  },
  props: {
    sideImg: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const target = ref(null);
    //获取首页执业
    const { result } = useLazyData(target, () => findZhiYe(206));

    return { goods: result, target };
  },
};
</script>

<style scoped lang="less">
.home-product {
  background: #fff;

  .sub {
    margin-bottom: 2px;
    a {
      padding: 2px 12px;
      font-size: 16px;
      border-radius: 4px;

      &:last-child {
        margin-right: 80px;
      }
    }
  }
  .box {
    display: flex;
    .box-img {
      width: 240px;
      height: 610px;

      .cover {
        width: 240px;
        height: 610px;
        //margin-right: 10px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
